import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { Button } from '../../../components/Button';

import styles from './index.module.css';

export interface ExistViewProps {
  imageSrc: string;
  onEdit?: () => void;
  onContinue?: () => void;
}

interface Props extends ExistViewProps, WithTranslation {}

const FreehandBodyDiagramPageExistView: React.FC<Props> = ({
  imageSrc,
  onEdit,
  onContinue,
  t,
}) => {
  return (
    <div>
      <img src={imageSrc} alt={t('review')} className={styles.Image} />
      <Button
        type="button"
        children={t('Edit Drawing')}
        invertColors={true}
        onClick={onEdit}
        className={styles.SecondaryButton}
      />
      <Button
        type="button"
        children={t('Continue')}
        onClick={onContinue}
        className={styles.PrimaryButton}
      />
    </div>
  );
};

export default withTranslation()(FreehandBodyDiagramPageExistView);
